import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import DeleteDialogModal from "../../control-components/custom-delete-dialog-box/delete-dialog";
import Loader from "../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { useNavigate } from "react-router";
import APP_ROUTES from "../../helper/app-routes";
import searchIcon from "../../assets/images/search.png";
import { Input } from "@progress/kendo-react-inputs";
import { MaskFormatted } from "../../helper/mask-helper";
import DateTimeHelper from "../../helper/date-time-helper";
import { TrainingServices } from "../../services/trainingServices";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";
import moment from "moment";
const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
function TrainingLinks() {
  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [loading, setLoading] = useState(false);
  const [trainingLinks, setTrainingLinks] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchApiQuery, setsearchApiQuery] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 90)));


  useEffect(() => {
    if (startDate && endDate) {
      getAllTrainingLinks();
    }
  }, [startDate, endDate]);

  const handleAddTrainingLink = () => {
    navigate(APP_ROUTES.ADD_TRAINING_LINKS);
  };
  const getAllTrainingLinks = async () => {
    const params = {
      startDate: moment(startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
    };
    setLoading(true);
    await TrainingServices.getAllTrainingLinks(params)
      .then((result) => {
        setTrainingLinks(result.resultData);
        setsearchApiQuery(result.resultData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };
  const trainingLinkDelete = async () => {
    setLoading(true);
    await TrainingServices.deleteTrainingLink(selectedId)
      .then((result) => {
        NotificationManager.success("Training Link deleted successfully.");
        setLoading(false);
        setDeleteConfirm(!isDeleteConfirm);
        getAllTrainingLinks();
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };
  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };
  const deleteSelectId = (id) => {
    setDeleteConfirm(true);
    setSelectedId(id);
  };
  const handleClose = () => {
    setDeleteConfirm(!isDeleteConfirm);
  };
  const handleFilter = (e) => {
    if (e.target.value === "") {
      setTrainingLinks(searchApiQuery);
    } else {
      const filterResult = searchApiQuery.filter(
        (item) =>
          item.url.toLowerCase().includes(e.target.value.toLowerCase()) ||
          item.title
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase()) ||
          item.trainingDate
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
      );
      setTrainingLinks(filterResult);
    }
    setSearchQuery(e.target.value);
  };
  return (
    <>
      <h4 className="address-title text-grey ">
        <span className="f-24">Training Links</span>
      </h4>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <div className="d-flex flex-wrap  align-items-center">
          <div className="mb-3 col-lg-3 col-md-3 col-3 date-field">
            <label className="form-label" style={{ fontSize: "0.875rem" }}>
              Start Date
            </label>
            <DatePickerKendoRct
              value={startDate ? new Date(startDate) : new Date()}
              onChange={(e) => setStartDate(e.value)}
            />
          </div>
          <div className="mb-3 col-lg-3 col-md-3 col-3 date-field">
            <label className="form-label" style={{ fontSize: "0.875rem" }}>
              End Date
            </label>
            <DatePickerKendoRct
              value={endDate ? new Date(endDate) : new Date(new Date().setDate(new Date().getDate() + 90))}
              onChange={(e) => setEndDate(e.value)}
            />
          </div>
          <div className="content-search-filter">
            <img src={searchIcon} alt="" className="search-icon" />
            <Input
              className="icon-searchinput"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => handleFilter(e)}
            />
          </div>
        </div>
        <button class="green-btn btn-primary" onClick={handleAddTrainingLink}>
          <span
            class="fa fa-plus"
            style={{ color: "#fff" }}
          ></span>{" "}
          Add Training Link
        </button>
      </div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading === true ? <Loader /> :
                  <Grid
                    data={orderBy(
                      trainingLinks.slice(page, pageSize + page),
                      sort
                    ).map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    checkboxElement
                    style={{
                      height: trainingLinks.length > 0 ? "100%" : "250px",
                    }}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    skip={page}
                    take={pageSize}
                    total={trainingLinks.length}
                    onPageChange={pageChange}
                    pageable={{
                      pageSizes: [10, 20, 30, 100, 500],
                    }}
                    sort={sort}
                    sortable={true}
                    onSortChange={(e) => {
                      setSort(e.sort);
                    }}
                  >
                    <GridColumn
                      className="cursor-default"
                      field="url"
                      title="Training Link"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.url;

                          return (
                            <td className="cursor-default">
                              <a href={field} target="_blank">
                                {field}
                              </a>
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="title"
                      title="Title"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="trainingDate"
                      title="Start Date"
                      cells={{
                        data: (props) => {
                          let field = moment(props?.dataItem?.trainingDate)
                            .local()
                            .format("M/D/YYYY hh:mm A");

                          return (
                            <td className="cursor-default">
                              {props.dataItem.trainingDate &&
                                props.dataItem.trainingDate != null
                                ? moment(props.dataItem.trainingDate)
                                  .local()
                                  .format("M/D/YYYY hh:mm A")
                                : "-"}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="expirationDate"
                      title="Expiration Date"
                      cells={{
                        data: (props) => {
                          let field = moment(props?.dataItem?.expirationDate)
                            .local()
                            .format("M/D/YYYY hh:mm A");
                          return (
                            <td className="cursor-default">
                              {props.dataItem.expirationDate &&
                                props.dataItem.expirationDate != null
                                ? moment(props.dataItem.expirationDate)
                                  .local()
                                  .format("M/D/YYYY hh:mm A")
                                : "-"}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="isActive"
                      title="Status"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.isActive;
                          return (
                            <td className="cursor-default">
                              {field === true ? (
                                <span
                                  className="fa fa-check-circle cursor-default  f-18"
                                  style={{ color: "green" }}
                                ></span>
                              ) : (
                                <span className="fa fa-times-circle cursor-default f-18 cross-icon-color"></span>
                              )}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      width={150}
                      title="Action"
                      filterable={false}
                      cells={{
                        data: (props) => {
                          let field = props.dataItem;
                          return (
                            <td>
                              <div className="row-3">
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                  onClick={() => deleteSelectId(field.id)}
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                        title="Delete"
                                      ></i>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                  onClick={() =>
                                    navigate(APP_ROUTES.EDIT_TRAINING_LINK, {
                                      state: field,
                                    })
                                  }
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i className="fas fa-edit" title="Edit"></i>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                          );
                        }
                      }}
                    />
                  </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isDeleteConfirm && (
        <DeleteDialogModal
          onClose={handleClose}
          title="TrainingLink"
          message="Training Link"
          handleDelete={trainingLinkDelete}
        />
      )}
    </>
  );
}
export default TrainingLinks;
